import { PARENT_SUBSIDIARY_VALUE } from 'src/modules/ManageEmployee/constants';

export const filterObject = (object, filter) => {
  const filteredObject = Object.keys(object)
    .filter(key => !filter.includes(key))
    .reduce((obj, key) => {
      return {
        ...obj,
        [key]: object[key]
      };
    }, {});

  return filteredObject;
};

export const withoutGeneralSalaryAndSalaryType = ({ salary, salaryType, subsidiary, id, ...rest }) => {
  if (subsidiary === PARENT_SUBSIDIARY_VALUE) {
    return { ...rest, subsidiary: null };
  }

  return { ...rest, subsidiary };
};
